import React from 'react';
import classNames from 'classnames';
import Navigation, { BaseNavigationProps } from './BaseNavigation';

const SecondaryNavigation = ({ className, ...rest }: BaseNavigationProps) => <Navigation className={classNames(className, 'secondary-navigation')} {...rest} />;

export default SecondaryNavigation;
